import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "./App.css";
import "./styles/brand-sections.css";
import DocumentDirection from "./components/common/DocumentDirection";
import LandingLogoNav from "./components/landing/LandingLogoNav";
import LandingRoutes from "./routes/LandingRoutes";
import { IS_LANDING } from "./constants/appConfig";
import { isRtlLanguage } from "./utils/i18n";

function LandingApp() {
  const { i18n } = useTranslation();
  const isRtl = isRtlLanguage(i18n.language);

  useEffect(() => {
    if (IS_LANDING && i18n.language !== "ar") {
      i18n.changeLanguage("ar");
    }
  }, [i18n]);

  return (
    <div
      id="main"
      className={`relative overflow-x-clip ${isRtl ? "arFont" : "enFont"}`}
    >
      <DocumentDirection />
      <LandingLogoNav />
      <main className="landing-main">
        <LandingRoutes />
      </main>
    </div>
  );
}

export default LandingApp;
